import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { references } from '@apexdesigner/schema-tools';

export const userActivityPeriod = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    periodStart: z.coerce
      .date()
      .describe(
        'Period Start - Start of the bucket, truncated to the period boundary (UTC instant)',
      ),

    requestCount: z
      .number()
      .nullable()
      .optional()
      .describe(
        'Request Count - Number of requests observed during the period. Null while\nthe period is in progress; set when the period closes. A row that keeps a\nnull count (process died mid-period) still counts as active time — null\njust means "count unknown".',
      ),

    userId: z.number().presentAs('reference').describe('Foreign key to User'),

    user: references('User'),
  })
  .describe(
    'Records that a user was active during one fixed-length time bucket.\nA row exists for a (user, period) pair when the user made at least one\nauthenticated request during that period, so total active time is simply\nthe row count times the period length.',
  )
  .as('UserActivityPeriod');

export { userActivityPeriod as userActivityPeriodSchema };
